
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'
import Top from 'src/Top.vue'

import Overview from 'src/Overview'
import Members from 'src/Members'
import Contact from 'src/Contact'
import Materials from 'vue-materials'
import Header from './components/Navbar'
import Footer from './components/Footbar'

import Translation from './resources/Translation'

Vue.use(VueI18n);
Vue.use(VueRouter);
Vue.use(Materials);
Vue.use(VueHead);

// var language = window.localStorage.getItem('language');
// if (language === '' || language === 'ja') {
Vue.config.lang = 'ja';
// } else {
//   Vue.config.lang = 'en';
// }

var locales = Translation.language;
Object.keys(locales).forEach(function (lang) {
  Vue.locale(lang, locales[lang])
});

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: Top },
    { path: '/overview', component: Overview },
    { path: '/members', component: Members },
    { path: '/contact', component: Contact }
  ]
});

Vue.component('app-header', Header);
Vue.component('app-footer', Footer);

new Vue({
  router
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js